/* tslint:disable */
import {
    defineMessages
} from 'react-intl';

export default defineMessages({
    bettingSlipMobile: {
        defaultMessage: 'Betslip',
        id: 'betslip.BettingSlipMobile'
    },
})